import { STATS_PERMISSIONS, SYSTEM_PERMISSIONS, CLIENT_PERMISSIONS, LINK_PERMISSIONS, RULE_PERMISSIONS, VISITOR_PERMISSIONS, BILLING_PERMISSIONS } from '../constants/permissions';

export interface RouteConfig {
  path: string;
  permission?: string;
  children?: RouteConfig[];
}

// 路由权限配置
export const ROUTE_PERMISSIONS: RouteConfig[] = [
  {
    path: '/dashboard',
    permission: STATS_PERMISSIONS.READ,
  },
  {
    path: '/users',
    permission: CLIENT_PERMISSIONS.SUB_ACCOUNT_READ,
  },
  {
    path: '/usage',
    permission: SYSTEM_PERMISSIONS.USAGE_READ,
  },
  {
    path: '/billing',
    permission: BILLING_PERMISSIONS.SUBSCRIPTION_READ,
  },
  {
    path: '/links',
    permission: LINK_PERMISSIONS.READ,
  },
  {
    path: '/operation-logs',
    permission: SYSTEM_PERMISSIONS.SECURITY_READ,
  },
  {
    path: '/rules',
    permission: RULE_PERMISSIONS.READ,
  },
  {
    path: '/ip-list',
    permission: VISITOR_PERMISSIONS.READ,
  },
  {
    path: '/visitors',
    permission: VISITOR_PERMISSIONS.READ,
  },
  {
    path: '/ip-stats',
    permission: VISITOR_PERMISSIONS.READ,
  },
  {
    path: '/blacklist',
    permission: VISITOR_PERMISSIONS.READ,
  },
  {
    path: '/statistics',
    permission: STATS_PERMISSIONS.READ,
  },
  {
    path: '/settings',
    permission: SYSTEM_PERMISSIONS.CONFIG_READ,
  },
  {
    path: '/system',
    permission: SYSTEM_PERMISSIONS.ALL,
    children: [
      {
        path: '/system/config',
        permission: SYSTEM_PERMISSIONS.CONFIG_READ,
      },
      {
        path: '/system/monitor',
        permission: SYSTEM_PERMISSIONS.MONITOR_READ,
      },
      {
        path: '/system/security',
        permission: SYSTEM_PERMISSIONS.SECURITY_READ,
      },
    ],
  },
];

// 检查路由权限
export const checkRoutePermission = (path: string, permissions: string[] | undefined): boolean => {
  // 安全检查：如果permissions为undefined、null或空数组，默认允许访问
  if (!permissions || !Array.isArray(permissions) || permissions.length === 0) {
    console.log(`🔍 权限检查: ${path} - 权限数组为空或无效，默认允许访问`);
    return true;
  }

  const hasSuperPermission = permissions.includes('*:*');
  if (hasSuperPermission) {
    console.log(`🔍 权限检查: ${path} - 超级管理员权限，允许访问`);
    return true;
  }

  const findRoutePermission = (routes: RouteConfig[], targetPath: string): string | undefined => {
    for (const route of routes) {
      if (route.path === targetPath) {
        return route.permission;
      }
      if (route.children) {
        const childPermission = findRoutePermission(route.children, targetPath);
        if (childPermission) return childPermission;
      }
    }
    return undefined;
  };

  const requiredPermission = findRoutePermission(ROUTE_PERMISSIONS, path);
  if (!requiredPermission) {
    console.log(`🔍 权限检查: ${path} - 路由未配置权限，默认允许访问`);
    return true; // 没有配置权限的路由默认允许访问
  }

  const hasPermission = permissions.includes(requiredPermission);
  console.log(`🔍 权限检查: ${path} - 需要权限: ${requiredPermission}, 结果: ${hasPermission}`);
  return hasPermission;
};